import React from 'react';
import Select from '../index';
import styled from 'styled-components';
import Icon from '../../Icon';

const PlaceholderContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;

  p {
    margin-left: 9px;
    margin-top: 3px;
    font-family: ${(props) => props.theme.fonts.sfcompact_light};
    font-size: 12px;
  }
`;

const SelectButton = ({
  isDisabled,
  options,
  onChange,
  placeholderIcon,
  placeholderLabel,
  customStyles = { control: {}, menuList: {} },
  ...otherProps
}) => (
  <Select
    value={''}
    style={{ minWidth: 120 }}
    isSearchable={false}
    placeholder={
      <PlaceholderContainer>
        <Icon icon={placeholderIcon} />
        <p>{placeholderLabel.toUpperCase()}</p>
      </PlaceholderContainer>
    }
    customStyles={{
      container: {
        height: 32,
        zIndex: 100
      },
      control: {
        border: 0,
        borderRadius: '24px',
        backgroundColor: '#2B3D54',
        height: '32px',
        width: 125,
        ...customStyles.control
      },
      menu: {
        minWidth: 120,
        width: 122,
        borderRadius: 4,
        marginTop: 8
      },
      valueContainer: {
        paddingLeft: 0,
        height: 32,
        marginBottom: 2,
        maxWidth: 'calc(100% - 30px)',
        color: 'white'
      },
      menuList: {
        borderRadius: 4,
        border: '1px solid #f4f5f5',
        ...customStyles.menuList
      },
      option: {
        fontSize: 12,
        fontFamily: 'SFCompactText'
      },
      placeholder: {
        color: 'white',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: 12,
        opacity: 1,
        fontFamily: 'SFCompactText',
        marginLeft: 5
      }
    }}
    options={options}
    onChange={onChange}
    dropdownProps={{
      styles: `margin-left:-25px;margin-bottom:2px;`,
      colorIcon: 'white'
    }}
    isDisabled={isDisabled}
    {...otherProps}
  />
);

export default SelectButton;
